'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function THFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-5k198dc8h", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-5k198dc8h)" }, /* @__PURE__ */ React.createElement("path", { fill: "#f50101", d: "M0 16h32v8H0zM0 0h32v6H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#3d58db", stroke: "#fff", strokeWidth: "3", d: "M33.5 6.5v11h-35v-11z" })))
  );
}

export { THFlag };
//# sourceMappingURL=TH.mjs.map
